import React from "react";
import { Amplify } from "aws-amplify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Admin2 from "./admin2";
import Client2 from "./client2";

// AWS Configuration - only use the aws-exports.js file
try {
  const awsconfig = require("./aws-exports").default;
  Amplify.configure(awsconfig);
} catch (e) {
  // AWS exports file not found - using minimal configuration

  // Just configure basic settings
  Amplify.configure({});
}

function App2() {
  return (
    <Router>
      <Routes>
        <Route path="/bossman" element={<Admin2 />} />
        <Route path="/*" element={<Client2 />} />
      </Routes>
    </Router>
  );
}

export default App2;